module.exports = __webpack_public_path__ + "img/47.0105e6d8.jpg";